export default "/images/vendor/@coreui/icons/svg/flag/cif-au.svg?d5210d36c09bb2cb436aaf2d1cde74a5";